import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';

type Variables = {
  startDatetime: string;
  endDatetime: string;
  carId: number;
  insuranceId: number;
  cancellationPolicyId?: number;
  deliveryDeliverToAddress?: string;
  deliveryReturnAddress?: string;
  discountCode?: string;
  pid?: string;
  c?: string;
};
export type CreateReservationResponse = {
  data: {
    stripeSecret: string;
    reservationId: number;
    ephemeralKey: string;
    customerSessionSecret: string;
    stripeCustomerId: string;
  };
};

export const useCreateReservation = createMutation<
  CreateReservationResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: 'v2/reservations',
      method: 'POST',
      data: {
        start_time: variables.startDatetime,
        end_time: variables.endDatetime,
        car_id: variables.carId,
        insurance_id: variables.insuranceId,
        cancellation_policy_id: variables.cancellationPolicyId,
        custom_pickup_location: variables.deliveryDeliverToAddress,
        custom_return_location: variables.deliveryReturnAddress,
        discount_code: variables.discountCode,
        pid: variables.pid,
        c: variables.c,
      },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
